import React from "react";
import { selectAuth } from "../../store/auth/selectors";
import { IApplicationState } from "../../store";
import { connect } from "react-redux";
import { IMenuItem } from "../../models/IMenuItem";
import FormSelect from "../forms/FormSelect";
import loadIntegrationOptions from "../../functions/loadIntegrationOptions";
import { IFormError } from "../forms/FormErrors";

export interface IDataDirectionSelectProps {
  token: string;
  id?: number;
  readonly?: boolean;
  onValueChange?: (val: IMenuItem | null) => void;
  required?: boolean;
  error?: IFormError;
}

const DataDirectionSelect = (props: IDataDirectionSelectProps) => {
  const { token, id, readonly, onValueChange, required, error } = props;
  const [items, setItems] = React.useState<IMenuItem[]>([]);
  const [item, setItem] = React.useState<IMenuItem | undefined | null>(null);

  React.useEffect(() => {
    loadIntegrationOptions(token, id, setItems, setItem, opts => opts.DataDirections);
  }, [token, id]);

  const onValChange = (val: IMenuItem | null) => {
    setItem(val);
    if (onValueChange) {
      onValueChange(val);
    }
  };

  return (
    <FormSelect
      name="DataDirection.ID"
      label="Data Direction (from Skyward's perspective)"
      prompt="Data Direction (from Skyward's perspective)"
      options={items}
      option={item}
      readonly={readonly}
      onValueChange={onValChange}
      required={required}
      error={error}
    />
  );
};

export default connect((state: IApplicationState) => ({
  ...selectAuth(state),
}))(DataDirectionSelect);
